<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">
          {{ $t("global") }} {{ $t("loyaltysettings") }}
        </div>
        <div class="section-subTitle my-2">{{ $t("manageAllGlobalLoyalty") }}</div>
      </div>
      <div v-if="getglobalsettings && getglobalsettings.length == 0">
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          variant="default"
          to="add-global-loyalty-settings"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
      </div>
  <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            filterIsActive => {
              getGloballoyaltysettingsList(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>


    </div>


    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div class="desg-list-container" style="margin-bottom:25px">
      <div class="desg-list-header justify-content-start">
        <div class="pr-3">{{ $tc("status", 2) }}</div>
        <div>
          <img
            v-if="this.columnName != 'ls_name'"
            @click="onSortValue('ls_name', 'asc')"
            src="@/assets/img/icons/updown.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else-if="isSort && isAscending"
            @click="onSortValue('ls_name', 'asc')"
            src="@/assets/img/icons/asc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          <img
            v-else
            @click="onSortValue('ls_name', 'desc')"
            src="@/assets/img/icons/desc.svg"
            class="cursor-pointer"
            width="15px"
            height="20px"
          />
          {{ $t("global") }} {{ $t("loyaltysettings") }} {{ $t("name") }}
        </div>
        
      </div>
      <ul class="desg-list " 
          v-if="getglobalsettings.length > 0"
      >
        <li
        class="justify-content-start"
          v-for="(globalsetting, globalsettingIndex) in getglobalsettings"
          :key="globalsettingIndex"
          
        >
         <div class="d-flex align-items-center">
            <!-- <label class="ios-switch">
              <input
                disabled
                :checked="globalsetting.ls_is_active"
                type="checkbox"
                class="ios-checkbox"
              />
              <span class="switch-slider"></span>
            </label> -->
            <StatusDot
              :status="globalsetting.ls_is_active ? 'active' : 'inactive'"
            />
            <b-dropdown right variant="edit" class="ml-2">
              <b-dropdown-item
                @click.prevent.stop="gotoRoute(globalsetting, 'Edit')"
              >
                <span class="edit-pen mr-1"></span>
                {{ $t("edit") }}
              </b-dropdown-item>
              <b-dropdown-item
                @click.prevent.stop="gotoRoute(globalsetting, 'View')"
              >
                <span class="icon-eye mr-1"></span>
                {{ $t("view") }}
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="pl-4">{{ globalsetting.ls_name }}</div>
         
        </li>
      </ul>
              <div v-else class="pb-3">
          <!-- <div>No Records Found.</div> -->
          <NoRecords classes="mb-0"/>
        </div>
    </div>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      gridView: false,
      listView: true,

      getglobalsettings: [],

      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: ""
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.getGloballoyaltysettingsList();
  },
  methods: {
    gotoRoute: function(data, type) {
      if (type == "Edit") {
        this.$router.push({
          path: "/marketing/edit-global-loyalty-settings",
          query: { ls_id: data.ls_id }
        });
      } else {
        this.$router.push({
          path: "/marketing/view-global-loyalty-settings",
          query: { ls_id: data.ls_id }
        });
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getGloballoyaltysettingsList();
      } else {
        this.currentPage = event;
        this.getGloballoyaltysettingsList();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getGloballoyaltysettingsList();
    },
    getGloballoyaltysettingsList: function(filterIsActive = "Y") {
      this.getglobalsettings = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
        filter_is_active: filterIsActive
      };
      MarketingService.GetGlobalLoyaltySettings(payload).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.getglobalsettings = data.Records;

            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              // this.selectedvalue = data.totalRows;
            }
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/listgloballoyaltysettings.vue